import React from 'react';

const PackageAddOns = ({ addOns, experiences, onAddonClick }) => {
  if (addOns.length === 0) return null;

  return (
    <div className="add-ons">
      <h4>Add-ons:</h4>
      <ul>
        {addOns.map((addOn, i) => {
          const isExperience = experiences.some(exp => exp.title === addOn.name);
          return (
            <li key={i}>
              {isExperience ? (
                <button 
                  className="experience-button"
                  onClick={() => onAddonClick(addOn.name)}
                >
                  {addOn.name} - ${addOn.price}
                </button>
              ) : (
                <span dangerouslySetInnerHTML={{__html: `${addOn.name} - ${addOn.price}`}} />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PackageAddOns;